module.exports = __webpack_public_path__ + "img/logo_techinasia.f3040941.png";